var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJmilogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "65 146 370 165",
    width: 740,
    height: 330,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#B52B2E",
    strokeWidth: 6,
    strokeLinecap: "butt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98,156 V247 A15,15 0 0 1 83,262 H74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,156 V247 A27,27 0 0 1 83,274 H74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,156 V247 A39,39 0 0 1 83,286 H74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,156 V247 A51,51 0 0 1 83,298 H74"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#B52B2E"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "187,296 187,156 193.3,156 247.15,259 240.85,259 193,167.48 193,296"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329,296 329,156 322.7,156 268.85,259 275.15,259 323,167.48 323,296"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201,156 207.3,156 261.15,259 254.85,259"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215,156 221.3,156 275.15,259 268.85,259"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.7,156 315,156 271.15,239.88 268,233.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.7,156 301,156 264.15,226.49 261,220.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199,296 199,188.52 205,199.99 205,296"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317,296 317,188.52 311,199.99 311,296"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211,296 211,211.47 217,222.95 217,296"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305,296 305,211.47 299,222.95 299,296"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223,296 223,234.42 229,245.9 229,296"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293,296 293,234.42 287,245.9 287,296"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 156,
    width: 6,
    height: 140
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 156,
    width: 6,
    height: 140
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404,
    y: 156,
    width: 6,
    height: 140
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 156,
    width: 6,
    height: 140
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJmilogo);
export default __webpack_public_path__ + "static/media/JMILOGO.9728e27bbecd1b778eb928cca851e57b.svg";
export { ForwardRef as ReactComponent };